import React from "react";

interface SidebarModalProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  className?: string;
}

const SidebarModal: React.FC<SidebarModalProps> = ({
  open,
  onClose,
  children,
  // title,
  className = "",
}) => {
  if (!open) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40"
        onClick={onClose}
      />

      {/* Sidebar Modal */}
      <div
        className={`fixed top-0 right-0 h-full bg-white shadow-2xl z-50 
  w-full sm:w-4/5 md:w-3/4  lg:w-1/2 xl:w-1/3 
  max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl rounded-md
  ${className}`}
      >
        {children}
      </div>
    </>
  );
};

export default SidebarModal;
